import React from 'react';
import * as Sentry from '@sentry/browser';

import { SENTRY_URL } from './services/constants';

Sentry.init({
  dsn: SENTRY_URL,
});

class ErrorReporter extends React.Component<{}, { error: any }> {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.REACT_APP_ENV !== 'local') {
      this.setState({ error });
      Sentry.withScope((scope) => {
        Object.keys(errorInfo).forEach((key) => {
          scope.setExtra(key, errorInfo[key]);
        });
        Sentry.captureException(error);
      });
    }
  }

  render() {
    if (this.state.error) {
      //render fallback UI
      return (
        <div className="row">
          <div className="col-md-5" style={{ margin: 'auto', marginTop: '200px' }}>
            <div className="alert alert-danger" role="alert">
              <h4 className="alert-heading">An error has occured!</h4>
              <p>It has been reported to our team</p>
            </div>
          </div>
        </div>
      );
    } else {
      //when there's not an error, render children untouched
      return this.props.children;
    }
  }
}

export default ErrorReporter;
